export default [
  {
    path: '/organization/list',
    name: 'organization-list',
    component: () => import('@/views/organization/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Organization List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Organization' }, { title: 'Organization List', active: true }],
      permissions: ['organization_list']
    }
  },
  {
    path: '/organization/add',
    name: 'create-organization',
    component: () => import('@/views/organization/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Organization',
      parent: 'OrganizationList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Organization', url: '/organization/list' },
        { title: 'Add Organization', active: true }
      ],
      permissions: ['organization_create']
    }
  },
  {
    path: '/organization/:id/edit',
    name: 'edit-organization',
    component: () => import('@/views/organization/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Organization',
      parent: 'OrganizationList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Organization', url: '/organization/list' },
        { title: 'Edit Organization', active: true }
      ],
      permissions: ['organization_edit', 'organization_view']
    }
  },
  {
    path: '/organization/:id/service-req-list',
    name: 'organization-service-req-list',
    component: () => import('@/views/organization/requests.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Service Request List',
      parent: 'OrganizationList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Organization', url: '/organization/list' },
        { title: 'Services', active: true }
      ],
      permissions: ['service_request_list']
    }
  },
  {
    path: '/organization/:id/organization-admin-list',
    name: 'organization-admin-list',
    component: () => import('@/views/organization/organization-admin.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Admin List',
      parent: 'OrganizationList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Organization', url: '/organization/list' },
        { title: 'Admin List', active: true }
      ],
      permissions: ['organization_admin_list']
    }
  }
]
